import { Box, Chip } from "@mui/material";
import type { FC } from "react";

interface Props {
  readonly eurExchangeRate: number;
}

/** Shows the internal EUR/PLN rate the backend used to convert PLN amounts in the displayed report data. */
const EurExchangeRateChip: FC<Props> = ({ eurExchangeRate }) => (
  <Box sx={{ mb: 2 }}>
    <Chip
      label={`Kurs EUR/PLN: ${eurExchangeRate}`}
      size="small"
      variant="outlined"
      sx={{ color: "text.secondary", borderColor: "rgba(0,0,0,0.12)" }}
    />
  </Box>
);

export default EurExchangeRateChip;
